import { useEffect, useState } from "react";
import Reveal from "@/components/Reveal";
import { YoutubeLogo } from "@phosphor-icons/react";

const CHANNEL_ID = "UCrDHXRc3e45b5icQ6QuKjcQ";
const LIVE_EMBED = `https://www.youtube.com/embed/live_stream?channel=${CHANNEL_ID}&autoplay=0`;
const CHANNEL_URL = "https://www.youtube.com/@vientodegracia9235";

const mxNow = () => new Date(new Date().toLocaleString("en-US", { timeZone: "America/Mexico_City" }));

const isLiveNow = (now) => now.getDay() === 0 && now.getHours() >= 10 && now.getHours() < 12;

const nextService = (now) => {
  const d = new Date(now);
  d.setHours(10, 0, 0, 0);
  let add = (7 - now.getDay()) % 7;
  if (add === 0 && now.getTime() >= d.getTime()) add = 7;
  d.setDate(d.getDate() + add);
  return d;
};

const pad = (n) => String(n).padStart(2, "0");

const EnVivo = () => {
  const [now, setNow] = useState(mxNow());

  useEffect(() => {
    const t = setInterval(() => setNow(mxNow()), 1000);
    return () => clearInterval(t);
  }, []);

  const live = isLiveNow(now);
  const diff = Math.max(0, nextService(now).getTime() - now.getTime());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const mins = Math.floor((diff % 3600000) / 60000);
  const secs = Math.floor((diff % 60000) / 1000);

  return (
    <section id="en-vivo" className="relative overflow-hidden bg-ink py-28 lg:py-36" data-testid="en-vivo-section">
      <div className="relative mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <div>
            <Reveal>
              <p className="mb-8 flex items-center gap-4 text-[10px] font-light uppercase tracking-[0.5em] text-fire" data-testid="en-vivo-eyebrow">
                {live && (
                  <span className="relative flex h-2.5 w-2.5" data-testid="en-vivo-live-dot">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-fire opacity-75" />
                    <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-fire" />
                  </span>
                )}
                Transmisión dominical
              </p>
              <h2 className="font-serif text-5xl leading-[0.95] tracking-tight text-paper sm:text-7xl" data-testid="en-vivo-title">
                {live ? (
                  <>Estamos <em className="italic text-gold">en vivo</em></>
                ) : (
                  <>Acompáñanos <em className="italic text-gold">en vivo</em></>
                )}
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              {live ? (
                <p className="mt-8 max-w-md text-sm font-light leading-relaxed tracking-wide text-smoke" data-testid="en-vivo-live-text">
                  Nuestro culto de celebración está transmitiendo ahora mismo. Únete desde donde estés —
                  domingos de 10:00 AM a 12:00 PM (hora de la Ciudad de México).
                </p>
              ) : (
                <div className="mt-10" data-testid="en-vivo-countdown">
                  <p className="text-[10px] font-light uppercase tracking-[0.4em] text-smoke">Próxima transmisión en</p>
                  <div className="mt-6 flex border border-white/10">
                    {[
                      { v: pad(days), l: "Días" },
                      { v: pad(hours), l: "Horas" },
                      { v: pad(mins), l: "Min" },
                      { v: pad(secs), l: "Seg" },
                    ].map((u, i) => (
                      <div key={u.l} className={`flex flex-1 flex-col items-center px-4 py-6 ${i > 0 ? "border-l border-white/10" : ""}`}>
                        <span className="font-serif text-4xl text-paper lg:text-5xl" data-testid={`countdown-${u.l.toLowerCase()}`}>{u.v}</span>
                        <span className="mt-2 text-[9px] font-light uppercase tracking-[0.3em] text-smoke">{u.l}</span>
                      </div>
                    ))}
                  </div>
                  <p className="mt-6 max-w-md text-sm font-light leading-relaxed tracking-wide text-smoke">
                    Domingos de 10:00 AM a 12:00 PM · hora de la Ciudad de México. Cuando comience el culto,
                    el reproductor aparecerá aquí automáticamente.
                  </p>
                </div>
              )}
            </Reveal>
          </div>

          <Reveal delay={0.2}>
            {live ? (
              <div className="border border-white/10" data-testid="en-vivo-player">
                <iframe
                  src={LIVE_EMBED}
                  title="Transmisión en vivo Viento de Gracia"
                  className="aspect-video w-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            ) : (
              <a
                href={CHANNEL_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="en-vivo-channel-btn"
                className="group flex items-center justify-between gap-6 border border-white/10 bg-surface p-10 transition-colors duration-500 hover:border-fire/60"
              >
                <div>
                  <p className="font-serif text-3xl italic text-paper">Activa el recordatorio</p>
                  <p className="mt-2 text-[10px] font-light uppercase tracking-[0.3em] text-smoke">YouTube · @vientodegracia9235</p>
                </div>
                <YoutubeLogo size={30} weight="light" className="shrink-0 text-smoke transition-colors duration-300 group-hover:text-fire" />
              </a>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default EnVivo;
